module.exports = __webpack_public_path__ + "img/AdvanceLogoWhite.86c7cde3.svg";